import { render, staticRenderFns } from "./LiuyanInfo.vue?vue&type=template&id=2ca8b794&scoped=true&lang=true&"
import script from "./LiuyanInfo.vue?vue&type=script&lang=js&"
export * from "./LiuyanInfo.vue?vue&type=script&lang=js&"
import style0 from "./LiuyanInfo.vue?vue&type=style&index=0&id=2ca8b794&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca8b794",
  null
  
)

export default component.exports